export default __webpack_public_path__ + "images/bxb_7c2d40.svg";